import styled, { css } from 'styled-components';

import Affix from './Affix';
import shapes from '../../../assets/styled/shapes';

/*
 * Makes sure the affixes background touch the
 * upper and bottom edges of the cell, without
 * compromising the real affix baseline alignment
 */

const AffixBackground = styled(Affix)`
  ${shapes.absoluteFullSize()};
  border: none;
  border-radius: 0;
  height: 100%;

  /*
   * Keeping content here to match width, but not showing
   * it in favor of real affix that is baseline aligned
   */
  color: transparent;

  ${({ theme }) =>
    theme.seam &&
    css`
      ${theme.seam}: auto;
    `}
`;

export default AffixBackground;
